import { api } from '../core';
import { MEDICAL_MATCH_CAN_RERUN_TAG } from '../constants';

/**
 * Why a full Medical Match rerun is not currently available:
 *   - JOB_IN_PROGRESS   — a full medmatch job is already running
 *   - NO_NEW_DOCUMENTS  — no AI-processed documents added since the last run
 *   - DOCUMENTS_PENDING — documents exist that haven't finished AI processing
 *
 * A `null` reason on the response means a rerun is available.
 */
export enum MedicalMatchRerunBlockedReason {
  JOB_IN_PROGRESS = 'JOB_IN_PROGRESS',
  NO_NEW_DOCUMENTS = 'NO_NEW_DOCUMENTS',
  DOCUMENTS_PENDING = 'DOCUMENTS_PENDING',
}

export interface CanRerunMedicalMatchResponse {
  canRerun: boolean;
  reason: MedicalMatchRerunBlockedReason | null;
}

interface GetCanRerunMedicalMatchProps {
  caseId: string;
}

const getCanRerunMedicalMatchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCanRerunMedicalMatch: builder.query<CanRerunMedicalMatchResponse, GetCanRerunMedicalMatchProps>({
      query: ({ caseId }: GetCanRerunMedicalMatchProps) => ({
        url: `medical-match/can-rerun?caseId=${encodeURIComponent(caseId)}`,
        method: 'GET',
      }),
      providesTags: (_result, _err, { caseId }) => [{ type: MEDICAL_MATCH_CAN_RERUN_TAG, id: caseId }],
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useGetCanRerunMedicalMatchQuery } = getCanRerunMedicalMatchApi;
